import { derived, writable } from 'svelte/store';

export const screenWidth = writable(0);
export const screenHeight = writable(0);
export const scrollY = writable(0);

export const isSmallestScreen = derived(screenWidth, (width) => width <= 359);
export const isSmallScreen = derived(screenWidth, (width) => width <= 575);
export const isMediumScreen = derived(screenWidth, (width) => width >= 576 && width <= 899);
export const isLargeScreen = derived(screenWidth, (width) => width >= 900);
export const isSmallerThanLargeScreen = derived(screenWidth, (width) => width <= 899);
export const isLargerThanSmallScreen = derived(screenWidth, (width) => width >= 576);
export const isSmallerThanSmallScreen = derived(screenWidth, (width) => width <= 399);
export const isSmallPhone = derived(
	[screenWidth, screenHeight],
	([width, height]) => width <= 360 && height <= 640
);

export const screenWidthClass = derived(
	[isSmallestScreen, isSmallScreen, isMediumScreen],
	([isSmallestScreen, isSmallScreen, isMediumScreen]) => {
		if (isSmallestScreen) {
			return 'screenWidthSmallest';
		}
		if (isSmallScreen) {
			return 'screenWidthSmall';
		}
		if (isMediumScreen) {
			return 'screenWidthMedium';
		}
		return 'screenWidthLarge';
	}
);
